import classNames from 'classnames';
import React, { HTMLAttributes, ReactNode } from 'react';

import css from './List.module.scss';

interface ListProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  className?: string;
  style?: object;
}

export const List = ({ className, style, children, ...rest }: ListProps) => {
  return (
    <div
      className={classNames(css.list, className)}
      role='list'
      style={style}
      {...rest}
    >
      {children}
    </div>
  );
};
